export enum CANCELLATION_POLICY_LOGIC {
  NON_REFUNDABLE = 'non_refundable',
  FREE = 'free',
  DEADLINE = 'deadline',
}
